import * as React from 'react'
export const Bs = (props: React.SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 513 342" width="1em" height="1em" {...props}>
    <path fill="#ffc72c" d="M0 0h513v342H0z" />
    <path fill="#00778b" d="M0 0h513v114H0zm0 228h513v114H0z" />
    <path d="M256 171 0 342V0z" />
  </svg>
)
